import { Location } from '@angular/common';
import { Component, DoCheck, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-pela-causa',
  templateUrl: './card-pela-causa.component.html',
  styleUrls: ['./card-pela-causa.component.scss'],
})
export class CardPelaCausaComponent implements OnInit, DoCheck {
  @Input() experiencias: any[] = [];
  @Input() quantidadeCards: number = 0;
  @Input() public carregando: boolean = true;

  public experiencia: any;
  public estaNaLP: boolean = false;

  public link;

  public width: number = window.innerWidth;

  //popup
  exibirPopupImg: boolean = false;

  constructor(private location: Location) {
    this.link = this.location.path();
  }

  ngOnInit(): void {
    if (this.link.includes('home')) {
      this.estaNaLP = true;
    }
  }

  ngDoCheck(): void {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = window.innerWidth;
  }

  abrirPopup(experiencia: any) {
    this.exibirPopupImg = true;
    this.experiencia = experiencia;
  }

  fecharPopup() {
    this.exibirPopupImg = false;
  }
}
